import React from 'react';
import { Grid, MenuItem, TextField } from '@material-ui/core';

import { useTranslation } from 'react-i18next';

import { RailzButton } from '@railzai/railz-uikit-react';

import useStyle from './style';

import { EventKind, WebhookLogDateRange, WebhookLogState } from 'types';
import { generateDropdown } from 'helpers/common.helper';

interface Props {
  selectedDateRange: WebhookLogDateRange;
  onDateRangeChange: (event: any) => void;
  selectedStatus: WebhookLogState;
  onStatusChange: (event: any) => void;
  selectedEvent;
  onEventChange: (event: any) => void;
  handleApplyFilter: () => void;
  handleClearFilter: () => void;
}

export default function WebhookLogFilterInputs({
  selectedDateRange,
  onDateRangeChange,
  selectedStatus,
  onStatusChange,
  selectedEvent,
  onEventChange,
  handleApplyFilter,
  handleClearFilter,
}: Props): JSX.Element {
  const classes = useStyle();

  const { t } = useTranslation();

  const statuses = generateDropdown(WebhookLogState);
  const eventsDropDown = generateDropdown(EventKind);
  const dateRangeDropdown = generateDropdown(WebhookLogDateRange);

  return (
    <>
      <Grid item lg={2} md={2} sm={12} xs={12} className={classes.statusWrapper}>
        <TextField
          fullWidth
          label={t('DASHBOARD_ENUM_WEBHOOK_LOG_CTA_DATE')}
          margin="dense"
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
          select
          value={selectedDateRange || ''}
          onChange={onDateRangeChange}
          data-testid="status-input"
        >
          {dateRangeDropdown.map((dateRange, index) => (
            <MenuItem key={index} value={dateRange.value}>
              {dateRange?.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item lg={1} md={1} sm={12} xs={12} className={classes.statusWrapper}>
        <TextField
          fullWidth
          label={t('DASHBOARD_DEVELOPERS_WEBHOOKS_LOG_STATUS')}
          margin="dense"
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
          select
          value={selectedStatus || ''}
          onChange={onStatusChange}
          data-testid="status-input"
        >
          {statuses.map((status, index) => (
            <MenuItem key={index} value={status.value}>
              {status?.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item lg={3} md={3} sm={12} xs={12} className={classes.statusWrapper}>
        <TextField
          fullWidth
          label={t('DASHBOARD_DEVELOPERS_WEBHOOKS_LOG_EVENT')}
          margin="dense"
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
          select
          value={selectedEvent || ''}
          onChange={onEventChange}
          data-testid="status-input"
        >
          {eventsDropDown.map((event, index) => (
            <MenuItem key={index} value={event.value}>
              {event?.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item lg={1} md={1} sm={12} xs={12}>
        <RailzButton
          size="medium"
          label={t('DASHBOARD_ENUM_WEBHOOK_LOG_CTA_APPLY')}
          className={classes.ctaButton}
          onClick={handleApplyFilter}
          data-testid="webhook-filter-apply"
        />
      </Grid>
      <Grid item lg={1} md={1} sm={12} xs={12}>
        <RailzButton
          size="medium"
          type="reset"
          label={t('DASHBOARD_ENUM_WEBHOOK_LOG_CTA_RESET')}
          className={classes.ctaButton}
          onClick={handleClearFilter}
          data-testid="webhook-filter-clear"
        />
      </Grid>
    </>
  );
}
